import styled from 'styled-components';
import { colors } from 'Constants/Colors';

export const OptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const Main = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 70%;
`;

export const AnswerRadio = styled.div`
  font-family: quicksand;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding-right: 1rem;
`;

export const iconStyle = {
  color: colors.GRAY_DARK,
  cursor: 'pointer',
};

export const dragStyle = {
  color: colors.GRAY_DARK,
  paddingTop: '0.15rem',
};

export const greyText = {
  color: colors.GRAY_DARK,
};

export default {
  OptionContainer,
  Main,
  AnswerRadio,
  iconStyle,
  dragStyle,
  greyText,
};
